/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import cn from "classnames";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Virtuoso } from "react-virtuoso";
import { SheetClose } from "~/components/ui/sheet";
import { useFontStyle } from "~/hook/useFontStyle";
import { LANG } from "~/utils/constant";
import { capitalize, removeUnderscore } from "~/utils/helper-funcations";
import ListImage from "./ListImage";
import { SearchItem } from "./type";

interface SearchListProps {
  data: SearchItem[];
  lang: string;
  activeIndex: number;
  itemRefs: React.MutableRefObject<(HTMLLIElement | null)[]>;
  handleApplySearch: (item: SearchItem, idx: number) => void;
  loadMore: () => void;
  search: string;
  Footer: any;
  isLoading?: boolean;
  moduleTab?: string;
  showNote?: boolean | null | undefined;
  isNavigating?: boolean;
}

// Skeleton component for loading state
const SkeletonItem: React.FC = () => (
  <ul>
    <li className="flex items-center justify-between px-4 py-2 rounded-lg">
      <div className="flex items-center gap-3 w-full">
        <div className="w-10 h-10 bg-gray-200 rounded-lg animate-pulse"></div>
        <div className="flex-1">
          <div className="h-4 bg-gray-200 rounded animate-pulse mb-2 w-3/4"></div>
          <div className="h-3 bg-gray-200 rounded animate-pulse w-1/2"></div>
        </div>
      </div>
    </li>
  </ul>
);

const SearchList: React.FC<SearchListProps> = ({
  data,
  lang,
  activeIndex,
  itemRefs,
  handleApplySearch,
  loadMore,
  Footer,
  showNote,
  moduleTab,
  search,
  isLoading,
  isNavigating,
}) => {
  const { t } = useTranslation();
  const { medium, mediumInter } = useFontStyle();

  if (isLoading && data.length === 0) {
    return (
      <div className="space-y-1">
        {Array.from({ length: 8 }).map((_, idx) => (
          <SkeletonItem key={idx} />
        ))}
      </div>
    );
  }

  const displayData = useMemo(() => {
    if (isLoading && data.length > 0) {
      const skeletonItems = Array.from({ length: 3 }, (_, idx) => ({
        id: `skeleton-${idx}`,
        isSkeleton: true,
        et: "",
        gt: "",
        img: { url: "" },
        mdl: "",
      }));
      return [...data, ...skeletonItems];
    }
    return data;
  }, [data, isLoading]);

  return (
    <Virtuoso
      data={displayData}
      endReached={loadMore}
      increaseViewportBy={10}
      components={{
        Footer,
        Header: () =>
          showNote ? (
            <>
              <div className="overflow-y-hidden flex items-center justify-center flex-col mb-2 -mt-2">
                <p className="text-sm text-center text-gray-500 py-4 bottom-divider">
                  {t("search.match_module_not_found", {
                    keyword: search ? search : "",
                    module_name: moduleTab ? capitalize(moduleTab) : "",
                  })}
                </p>
                <div style={{ width: "50%" }} className="border-t border-gray-200" />
              </div>
              <div className="overflow-y-hidden flex-col mb-2 -mt-2">
                <p className="text-sm text-gray-700 py-2 capitalize ml-4">{t("search.related_results")} :-</p>
              </div>
            </>
          ) : null,
      }}
      itemContent={(idx, item: any) => {
        // Render skeleton item if it's a placeholder
        if (item.isSkeleton) {
          return <SkeletonItem key={`skeleton-${idx}`} />;
        }
        return (
          <ul>
            <li
              key={idx}
              ref={(el) => (itemRefs.current[idx] = el)}
              className={cn(
                "flex items-center justify-between px-4 py-2 rounded-lg hover:bg-bg-cardBg cursor-pointer transition overflow-x-hidden search-content-scroll",
                activeIndex === idx ? "bg-cardBg" : "hover:bg-cardBg",
                isNavigating && "opacity-50 pointer-events-none",
              )}
              onClick={() => !isNavigating && handleApplySearch(item, idx)}
            >
              <SheetClose className="flex items-center gap-3">
                <div>
                  <ListImage url={item.img.url} alt={item.et} />
                </div>
                <div className="text-start">
                  <p
                    title={LANG.gujarati === lang ? item.gt : item.et}
                    className={cn("font-medium text-sm line-clamp-1  text-textColor capitalize tracking-wide overflow-hidden", medium)}
                  >
                    {LANG.gujarati === lang ? item.gt : item.et}
                  </p>
                  <div className={cn("text-xs line-clamp-1 capitalize text-textHeadingColor overflow-hidden", mediumInter)}>
                    <span>{removeUnderscore(item.mdl)}</span>
                  </div>
                </div>
              </SheetClose>
            </li>
          </ul>
        );
      }}
    />
  );
};

export default SearchList;
